import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  makeStyles,
  Grid,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
  Typography,
  Box,
  FormControl,
  Select,
  Divider,
  Checkbox,
  ListItemText,
  Dialog,
  DialogContent,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@material-ui/core";
import { DialogTitle, FormControlLabel } from "@material-ui/core";

import { smlUrl } from "../../../../../utils/config";
import {
  fetchPurchaseOrders,
  fetchPurchaseOrdersFilters,
} from "../../../containers/actions/common/purchaseOrderAction";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Clear, Refresh } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../helpers/previousProps";
import {
  DESTROY_BACKDROP,
  FETCH_PURCHASE_ORDER_LOADING,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import jwtDecode from "jwt-decode";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import PaginationInput from "../models/pagination/PaginationInput";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import Block from "./QuickSummary/Block";
import { Autocomplete } from "@material-ui/lab";
import ApprovedPurchaseOrderTable from "./QuickSummary/ApprovedPurchaseOrderTable";
import StyledButton from "../../../../common/models/Button";
import BackDropLoading from "../models/BackDrop";
import StyledDialog from "../../../../common/models/Dialog";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
// import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #000000de",
    borderRadius: "0.5rem",
    padding: "0.3rem",
    width: "20px",
    height: "20px",
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  logoHeight: {
    height: "inherit",
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "2.8rem",
    paddingRight: "2.8rem",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
  dpFlx: { display: "flex" },
  algnCntr: { alignItems: "center" },
  pointer: { cursor: "pointer" },
  onHvrUndrline: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  BtnSty1: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid black",
    },
  },
  inputBaseRoot: {
    padding: "0px",
    paddingRight: "14px",
    height: "40px",
  },
  dialogPaper: {
    padding: theme.spacing(3),
    minWidth: 500,
    borderRadius: 10,
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  saveButton: {
    backgroundColor: "#ff5722",
    color: "#fff",
    textTransform: "none",
    fontWeight: "bold",
    padding: "3px 30px",
    borderRadius: "14px",
    "&:hover": {
      backgroundColor: "#e64a19",
    },
  },
  cancelButton: {
    textTransform: "none",
    fontWeight: "bold",
    marginRight: "auto", // Aligns left
  },
  formGroup: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1),
  },
  saveButtonContainer: {
    display: "flex",
    justifyContent: "center", // Centers the button
    width: "100%",
    paddingBottom: theme.spacing(2),
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  accordionSummary: {
    "&.Mui-expanded": {
      minHeight: "50px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "10px 0px",
    },
  },
}));

const ApprovedPurchaseOrderDashboard = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  // const location = useLocation();
  //       const previousFilter = location.state?.fiters;
  //       console.log(previousFilter)
  const { customizeTable, savedFilter, featuresAccess } = props;
  const tokenData = jwtDecode(localStorage.getItem("authToken"));
  const [searchField, setSearchField] = useState("all");
  const [searchValue, setSearchValue] = useState(null);
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);
  const [filterByDate, setFilterByDates] = useState("0");
  const [vendorMosymphonyID, setVendorMosymphonyID] = useState("0");
  const [scheduleAgreementStatusID, setScheduleAgreementStatusID] =
    useState("0");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
  const [totalPages, setTotalPages] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);
  const [fetchPurchaseOrderData, setFetchPurchaseOrderData] = useState([]);

  const [columns, setColumns] = useState(
    customizeTable?.poApprovedColumn ? customizeTable.poApprovedColumn : []
  );
  const [open, setOpen] = useState(false);
  // const [poStatusArray, setPOStatusArray] = useState([]);

  const [searchSelectValue, setSearchSelectValue] = useState(null);
  const [plantList, setPlantList] = useState([]);
  const [plannerList, setPlannerList] = useState([]);
  const [selectedPlantIdList, setSelectedPlantIdList] = useState(
    savedFilter?.plantListFilter && Array.isArray(savedFilter?.plantListFilter)
      ? savedFilter?.plantListFilter
      : []
  );
  const [SelectedCMOList, setSelectedCMOList] = useState(
    savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
      ? savedFilter?.cmoListFilter
      : []
  );
  const [selectedPlannerList, setSelectedPlannerList] = useState(
    savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
      ? savedFilter?.plannerUserId
      : []
  );
  const [filteredPlantList, setFilteredPlantList] = useState(
    savedFilter?.plantListFilter && Array.isArray(savedFilter?.plantListFilter)
      ? savedFilter?.plantListFilter
      : []
  );
  const [filteredVendorMosymphonyIDList, setFilteredVendorMosymphonyIDList] =
    useState(
      savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
        ? savedFilter?.cmoListFilter
        : []
    );
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  // const [savedFilter, setSavedFilter] = useState(null);
  const [plantIdOptions, setPlantIdOptions] = useState([]);
  const [plannerOptions, setPlannerOptions] = useState([]);

  const [supplyTypes, setSupplyTypes] = useState([]);

  const [drugTypes, setDrugTypes] = useState([]);

  const [plantTypes, setPlantTypes] = useState([]);

  let previousVendorList = useRef([]);
  let previousPlantList = useRef([]);
  let previousPlannerList = useRef([]);

  const screenAccess = useSelector(
    (state) => state.pcmp.common.accessControl.screensAccess?.data
  );

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  const purchaseOrderData = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.purchaseOrderDetails
      ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetails?.data
      : []
  );

  let prevPurchaseOrderData = usePrevious(purchaseOrderData);

  useEffect(() => {
    let plantList = savedFilter?.plantListFilter
      ? savedFilter?.plantListFilter
      : [];

    let cmoList = savedFilter?.cmoListFilter ? savedFilter?.cmoListFilter : [];

    let plannerList = savedFilter?.plannerUserId
      ? savedFilter?.plannerUserId
      : [];

    let dateFilter = 0;

    setSelectedPlantIdList(Array.isArray(plantList) ? plantList : []);

    setSelectedCMOList(Array.isArray(cmoList) ? cmoList : []);

    setSelectedPlannerList(Array.isArray(plannerList) ? plannerList : []);

    let filteredPlannerList = Array.isArray(plannerList) ? plannerList : [];

    let filteredCMOList = Array.isArray(cmoList) ? cmoList : [];

    // filteredPlannerList.forEach((val) => {
    //   if (plannerOptions.filter((val1) => val1.saasUserID === val).length > 0) {
    //     let orgIds = plannerOptions.filter((val1) => val1.saasUserID === val)[0]
    //       .organization_ids;
    //     filteredCMOList = [...new Set([...orgIds, ...filteredCMOList])];
    //   }
    // });

    setFilterByDates(dateFilter);

    setFilteredPlantList(Array.isArray(plantList) ? plantList : []);
    setFilteredVendorMosymphonyIDList(filteredCMOList);

    setColumns(
      customizeTable?.poApprovedColumn ? customizeTable.poApprovedColumn : []
    );

    // setCurrentPage(previousFilter?.pageNumber ? previousFilter?.pageNumber : 1)

    // setRowsPerPage(previousFilter?.pageSize ? previousFilter?.pageSize : 5)

    // setSearchField(previousFilter?.searchField ? previousFilter?.searchField : 'all')

    // setSearchValue(previousFilter?.searchValue ? previousFilter?.searchValue : null)

    previousVendorList.current = Array.isArray(cmoList) ? cmoList : [];

    previousPlantList.current = Array.isArray(plantList) ? plantList : [];

    previousPlannerList.current = Array.isArray(plannerList) ? plannerList : [];

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchValue,
        noOfDaysAgo: dateFilter,
        collaboratorTypeID: tokenData.collaborator_type_id,
        // vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: Array.isArray(plantList) ? plantList : [],
        vendorMosymphonyIDList: filteredCMOList,
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        plannerEmailIDs: filteredPlannerList,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customizeTable, savedFilter, plannerOptions]);

  useEffect(() => {
    // dispatch({
    //   type: FETCH_PURCHASE_ORDER_LOADING,
    //   payload: true,
    // });
    // dispatch(
    //         fetchPurchaseOrders({
    //           searchField : searchField,
    //           searchValue : searchValue,
    //           noOfDaysAgo: filterByDate,
    //           collaboratorTypeID :tokenData.collaborator_type_id,
    //           vendorMosymphonyID : parseInt(vendorMosymphonyID),
    //           scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
    //           fgPoApprovedFlag: true,
    //           plantCodeList: selectedPlantIdList,
    //           vendorMosymphonyIDList: SelectedCMOList,
    //           pageNumber: currentPage,
    //           pageSize : rowsPerPage
    //         })
    //       );
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }
    // axios
    //   .get(
    //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllPOStatuses`
    //   )
    //   .then((res) => {
    //     if (res.data.status) {
    //       setPOStatusArray(
    //         res.data?.data?.poStatuses ? res.data?.data?.poStatuses : []
    //       );
    //     }
    //   })
    //   .catch((err) => console.log(err));

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setSupplyTypes(
            res.data?.data?.supplyTypeList ? res.data?.data?.supplyTypeList : []
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setDrugTypes(
            res.data?.data?.drugTypeList ? res.data?.data?.drugTypeList : []
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setPlantTypes(
            res.data?.data?.plantTypeList ? res.data?.data?.plantTypeList : []
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllVendorPlants`
      )
      .then((res) => {
        if (res.data?.status) {
          setPlantList(
            res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
          );
          setPlantIdOptions(
            res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${appUrl}/user/getPlannerDetails`)
      .then((res) => {
        if (res.data?.status) {
          setPlannerOptions(res.data?.data ? res.data?.data : []);
          setPlannerList(res.data?.data ? res.data?.data : []);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(purchaseOrderData) !==
      JSON.stringify(prevPurchaseOrderData)
    ) {
      setFetchPurchaseOrderData(purchaseOrderData);
    }
  }, [purchaseOrderData, prevPurchaseOrderData]);

  let showPagination = fetchPurchaseOrderData?.totalNoOfRecords > 0; // Always show if the data is fetched

  const paginateData = () => {
    const totalItems = fetchPurchaseOrderData?.totalNoOfRecords || 0;
    const pages = Math.ceil(totalItems / rowsPerPage);

    if (pages !== totalPages) {
      setTotalPages(pages);
    }

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    // Ensure fetchShipmentDashboardData is an array before slicing
    // const newPaginatedData = Array.isArray(
    //   fetchPurchaseOrderData?.SADetails
    // )
    //   ? fetchPurchaseOrderData.SADetails.slice(
    //       startIndex,
    //       endIndex
    //     )
    //   : [];
    let newPaginatedData;
    if (
      fetchPurchaseOrderData &&
      Array.isArray(fetchPurchaseOrderData.SADetails)
    ) {
      newPaginatedData = fetchPurchaseOrderData.SADetails.slice(
        startIndex,
        endIndex
      );
    } else {
      newPaginatedData = [];
    }

    // Only update paginatedData if it has actually changed
    if (JSON.stringify(newPaginatedData) !== JSON.stringify(paginatedData)) {
      setPaginatedData(newPaginatedData);
    }
  };

  useEffect(() => {
    paginateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPurchaseOrderData, currentPage, rowsPerPage]);

  let errors = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.purchaseOrderDetails
      ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetails
      : {
          status: false,
          errorDescription:
            "Something went wrong. Please contact Schrocken Support.",
        }
  );

  let status = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.purchaseOrderDetails?.status
      ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetails?.status
      : 0
  );

  let fetchPurchaseOrderDataLoading = useSelector(
    (state) => state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsLoading
  );

  const poQuickSummary = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.poQuickSummary
      ? state.pcmp.common?.purchaseOrder?.poQuickSummary?.data?.POQuickSummary
      : {}
  );

  let poQuickSummaryLoading = useSelector(
    (state) => state.pcmp.common?.purchaseOrder?.poQuickSummaryLoading
  );

  const handleClearFilters = () => {
    previousPlannerList.current = [];
    previousPlantList.current = [];
    previousVendorList.current = [];
    setSearchField("all");
    setSearchValue("");
    setFilterByDates("0");
    setVendorMosymphonyID("0");
    setScheduleAgreementStatusID("0");
    setCurrentPage(1);
    setSearchSelectValue(null);
    setSelectedCMOList([]);
    setSelectedPlantIdList([]);
    setSelectedPlannerList([]);
    setFilteredPlantList([]);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrders({
        searchField: "all",
        searchValue: null,
        noOfDaysAgo: 0,
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: 0,
        scheduleAgreementStatusID: 0,
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: [],
        vendorMosymphonyIDList: [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerEmailIDs: [],
      })
    );
  };

  // const handleFilterByDates = (event) => {
  //   setFilterByDates(event.target.value);
  //   setCurrentPage(1);
  //   dispatch({
  //     type: FETCH_PURCHASE_ORDER_LOADING,
  //     payload: true,
  //   });
  //   dispatch(
  //     fetchPurchaseOrders({
  //       searchField: searchField,
  //       searchValue: searchValue,
  //       noOfDaysAgo: parseInt(event.target.value),
  //       collaboratorTypeID: tokenData.collaborator_type_id,
  //       vendorMosymphonyID: parseInt(vendorMosymphonyID),
  //       scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
  //       fgPoApprovedFlag: true,
  //       plantCodeList: filteredPlantList,
  //       vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
  //       pageNumber: 1,
  //       pageSize: rowsPerPage,
  //     })
  //   );
  // };

  // const handleFilterByCMO = (event) => {
  //   setVendorMosymphonyID(event.target.value);
  //   setCurrentPage(1);
  //   dispatch({
  //     type: FETCH_PURCHASE_ORDER_LOADING,
  //     payload: true,
  //   });
  //   dispatch(
  //     fetchPurchaseOrders({
  //       searchField: searchField,
  //       searchValue: searchValue,
  //       noOfDaysAgo: parseInt(filterByDate),
  //       collaboratorTypeID: tokenData.collaborator_type_id,
  //       vendorMosymphonyID: event.target.value,
  //       scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
  //       fgPoApprovedFlag: true,
  //       plantCodeList: filteredPlantList,
  //       vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
  //       pageNumber: 1,
  //       pageSize: rowsPerPage,
  //     })
  //   );
  // };

  const handleRefresh = () => {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchValue,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        plannerEmailIDs: selectedPlannerList,
      })
    );
  };

  const handleClearSearch = () => {
    if (["Supply type", "Drug type", "Plant type"].includes(searchField)) {
      if (SelectedCMOList.length > 0) {
        setPlantList(
          plantIdOptions.filter((val) =>
            SelectedCMOList.includes(val.vendorMosymphonyID)
          )
        );
      } else {
        setPlantList(plantIdOptions);
      }
    }
    setSearchValue("");
    setSearchSelectValue(null);
    setCurrentPage(1); //Reset to first page
    if (isSearchTriggered) {
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: true,
      });
      dispatch(
        fetchPurchaseOrders({
          searchField: "all",
          searchValue: null,
          noOfDaysAgo: parseInt(filterByDate),
          collaboratorTypeID: tokenData.collaborator_type_id,
          vendorMosymphonyID: parseInt(vendorMosymphonyID),
          scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
          fgPoApprovedFlag: true,

          viewPOOption: "all",
          plantCodeList: filteredPlantList,
          vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
          pageNumber: 1,
          pageSize: rowsPerPage,
          plannerEmailIDs: selectedPlannerList,
        })
      );
    }
  };

  const validateSearchValue = (value) => {
    const trimmedValue = value.trim();

    if (searchField === "PO Number") {
      // Allow only numbers
      const regex = /^[0-9]+$/;
      return regex.test(trimmedValue); // Returns true if valid
    } else if (searchField === "Product Code") {
      // Allow numbers and hyphens
      const regex = /^[0-9\-]+$/; // Match one or more digits and hyphens
      return regex.test(trimmedValue); // Returns true if valid
    } else if (searchField === "Product description") {
      // Allow alphabets and spaces
      // const regex = /^[A-Za-z]+( [A-Za-z]+)*$/; // Match one or more letters followed by spaces and more letters
      // return regex.test(trimmedValue); // Returns true if valid
      return true;
    }

    return true; // Default to valid if no condition matches
  };

  const handleSearchField = (event) => {
    // setCurrentPage(1);
    setSearchField(event.target.value);
    setSearchValue(null);
    setSearchSelectValue(null);
  };

  const handleSearchValue = (event) => {
    const newValue = event.target.value;
    if (validateSearchValue(newValue) || newValue === "") {
      // setCurrentPage(1);
      setSearchValue(newValue);
    }
  };

  const handleFilterByPOStatus = (val) => {
    setScheduleAgreementStatusID(val.target.value);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchField !== "all" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        // vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(val.target.value),
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerEmailIDs: selectedPlannerList,
      })
    );
  };

  // const handleCleanQuickSummary = () => {
  //   setScheduleAgreementStatusID("0");
  //   setCurrentPage(1); //Reset to first page
  //   dispatch({
  //     type: FETCH_PURCHASE_ORDER_LOADING,
  //     payload: true,
  //   });
  //   dispatch(
  //     fetchPurchaseOrders({
  //       searchField: searchField,
  //       searchValue: searchField !== "all" ? searchValue : null,
  //       noOfDaysAgo: parseInt(filterByDate),
  //       collaboratorTypeID: tokenData.collaborator_type_id,
  //       vendorMosymphonyID: parseInt(vendorMosymphonyID),
  //       scheduleAgreementStatusID: 0,
  //       fgPoApprovedFlag: true,
  //       plantCodeList: filteredPlantList,
  //       vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
  //       pageNumber: 1,
  //       pageSize: rowsPerPage,
  //     })
  //   );
  // };

  const handleSearchClick = () => {
    let plantArray = filteredPlantList;
    if (
      searchField === "Supply type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.supplyType === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
    } else if (
      searchField === "Drug type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.drugType === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
    } else if (
      searchField === "Plant type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.plantType === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
    }

    if (selectedPlantIdList.length > 0) {
      setSelectedPlantIdList(
        selectedPlantIdList.filter((value) => plantArray.includes(value))
      );
      setFilteredPlantList(
        selectedPlantIdList.filter((value) => plantArray.includes(value))
      );
      plantArray = selectedPlantIdList.filter((value) =>
        plantArray.includes(value)
      );
    } else {
      setFilteredPlantList(plantArray);
    }

    setIsSearchTriggered(true);
    setCurrentPage(1); //Reset to first page
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    let searchVal = typeof searchValue === 'string' && searchValue !== searchValue.trim() ? searchValue.trim() : searchValue
    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchField !== "all" ? searchVal : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
        fgPoApprovedFlag: true,
        plantCodeList: plantArray,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerEmailIDs: selectedPlannerList,
      })
    );
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);

    setCurrentPage(1); //Reset to first page
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchField !== "all" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
        pageNumber: 1,
        pageSize: newRowsPerPage,
        plannerEmailIDs: selectedPlannerList,
      })
    );
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrders({
        searchField: searchField,
        searchValue: searchField !== "all" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
        fgPoApprovedFlag: true,

        viewPOOption: "all",
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
        pageNumber: newPage,
        pageSize: rowsPerPage,
        plannerEmailIDs: selectedPlannerList,
      })
    );
  };

  const handleViewClick = (poNumber, vendorName) => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/schedule agreements`,
      {
        state: {
          searchText: poNumber, // Replace with actual PO number
          viewByValue: "all",
          filterByValue: vendorName, // Vendor name
        },
      }
    );
  };

  const openPOLineDetails = (data) => {
    let filters = {
      searchField: searchField,
      searchValue: searchValue,
      fgPoApprovedFlag: true,
      cmoListFilter: SelectedCMOList,
      plantListFilter: selectedPlantIdList,
      plannerUserId: selectedPlannerList,
      dateOfCreation: filterByDate,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
    };

    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorders/lineitems`,
      {
        data: data,
        fiters: filters,
      }
    );
  };

  const handleChangeCMOList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedCMOList(
        SelectedCMOList.length === cmoMemberWithId.length
          ? []
          : cmoMemberWithId.map((val) => val.organization_id)
      );
      setPlantList(
        plantIdOptions.filter((val) =>
          cmoMemberWithId
            .map((val) => val.organization_id)
            .includes(val.vendorMosymphonyID)
        )
      );
      setPlannerList(
        plannerOptions.filter((val) =>
          val?.organization_ids
            ? val.organization_ids.some((item) =>
                cmoMemberWithId.map((val) => val.organization_id).includes(item)
              )
            : false
        )
      );
    } else {
      setSelectedCMOList(value);
      if (value.length > 0) {
        setPlantList(
          plantIdOptions.filter((val) => value.includes(val.vendorMosymphonyID))
        );
        setPlannerList(
          plannerOptions.filter((val) =>
            val?.organization_ids
              ? val?.organization_ids.some((item) => value.includes(item))
              : false
          )
        );
      } else {
        setPlantList(plantIdOptions);
        setPlannerList(plannerOptions);
      }

      if (selectedPlantIdList.length > 0 && value.length > 0) {
        setSelectedPlantIdList(
          selectedPlantIdList.filter((val) => {
            const match = plantIdOptions.find((val1) => val === val1.plantCode);
            return match ? value.includes(match.vendorMosymphonyID) : false;
          })
        );
      }
    }
  };

  const handleSelectChangeListLosesFocus = (type) => {
    let filteredCMO;
    let filteredPlantIds;
    if (type === "cmo") {
      setFilteredVendorMosymphonyIDList(SelectedCMOList);
      filteredCMO = SelectedCMOList;
      filteredPlantIds = selectedPlantIdList;
    } else if (type === "plantID") {
      setFilteredPlantList(
        selectedPlantIdList.length > 0 ? selectedPlantIdList : []
      );
      filteredCMO = filteredVendorMosymphonyIDList;
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else {
      filteredCMO = filteredVendorMosymphonyIDList;
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    }

    if (
      !(
        previousVendorList.current.length === SelectedCMOList.length &&
        JSON.stringify([...previousVendorList.current].sort()) ===
          JSON.stringify([...SelectedCMOList].sort())
      ) ||
      !(
        previousPlantList.current.length === selectedPlantIdList.length &&
        JSON.stringify([...previousPlantList.current].sort()) ===
          JSON.stringify([...selectedPlantIdList].sort())
      ) ||
      !(
        previousPlannerList.current.length === selectedPlannerList.length &&
        JSON.stringify([...previousPlannerList.current].sort()) ===
          JSON.stringify([...selectedPlannerList].sort())
      )
    ) {
      previousPlannerList.current = selectedPlannerList;
      previousPlantList.current = selectedPlantIdList;
      previousVendorList.current = SelectedCMOList;
      setCurrentPage(1);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: true,
      });
      dispatch(
        fetchPurchaseOrders({
          searchField: searchField,
          searchValue: searchField !== "all" ? searchValue : null,
          noOfDaysAgo: parseInt(filterByDate),
          collaboratorTypeID: tokenData.collaborator_type_id,
          vendorMosymphonyID: parseInt(vendorMosymphonyID),
          scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
          fgPoApprovedFlag: true,

          viewPOOption: "all",
          plantCodeList: filteredPlantIds,
          vendorMosymphonyIDList: filteredCMO,
          pageNumber: 1,
          pageSize: rowsPerPage,
          plannerEmailIDs: selectedPlannerList,
        })
      );
    }
  };

  const getDisplayCMOFilterValue = () => {
    if (SelectedCMOList.length === cmoMemberWithId.length && SelectedCMOList.length !== 1)
      return "All";
    else if (SelectedCMOList.length === cmoMemberWithId.length && SelectedCMOList.length === 1) {
      let result = cmoMemberWithId.filter((val) => SelectedCMOList[0] == val.organization_id)
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return 'All';
      }
    }
    else if (SelectedCMOList.length === 1) {
      let result = cmoMemberWithId.filter((val) => SelectedCMOList[0] == val.organization_id)
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return 'All';
      }
    }
    return "Multiple selection";
  };

  const handleChangePlantIdList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedPlantIdList(
        selectedPlantIdList.length === plantList.length
          ? []
          : plantList.map((val) => val.plantCode)
      );
    } else {
      setSelectedPlantIdList(value);
    }
  };

  const getDisplayPlantIDValue = () => {
    if (selectedPlantIdList.length === plantList.length && selectedPlantIdList.length !== 1)
      return "All";
    else if (selectedPlantIdList.length === plantList.length && selectedPlantIdList.length === 1) {
      let result = plantList.filter((val) => selectedPlantIdList[0] == val.plantCode)
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return 'All';
      }
    }
    else if (selectedPlantIdList.length === 1) {
      let result = plantList.filter((val) => selectedPlantIdList[0] == val.plantCode)
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return 'All';
      }
    }
    return "Multiple selection";
  };

  const handleChangePlannerList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedPlannerList(
        selectedPlannerList.length === plannerList.length
          ? []
          : plannerList.map((val) => val.email)
      );

      // if (SelectedCMOList.length > 0) {
      //   setFilteredVendorMosymphonyIDList(SelectedCMOList);
      // } else {
      //   let cmoList = [];
      //   plannerList.forEach((val) => {
      //     let orgIds = val.organization_ids;
      //     cmoList = [...new Set([...orgIds, ...cmoList, ...SelectedCMOList])];
      //   });
      //   setFilteredVendorMosymphonyIDList(cmoList);
      // }
    } else {
      setSelectedPlannerList(value);
      // if (SelectedCMOList.length > 0) {
      //   setFilteredVendorMosymphonyIDList(SelectedCMOList);
      // } else {
      //   let cmoList = [];
      //   value.forEach((val) => {
      //     if (
      //       plannerList.filter((val1) => val1.saasUserID === val).length > 0
      //     ) {
      //       let orgIds = plannerList.filter(
      //         (val1) => val1.saasUserID === val
      //       )[0].organization_ids;
      //       cmoList = [...new Set([...orgIds, ...cmoList, ...SelectedCMOList])];
      //     }
      //   });
      //   setFilteredVendorMosymphonyIDList(cmoList);
      // }
    }
  };

  const getDisplayPlannerValue = () => {
    if (selectedPlannerList.length === plannerList.length && selectedPlannerList.length !== 1)
      return "All";
    else if (selectedPlannerList.length === plannerList.length && selectedPlannerList.length === 1) {
      let result = plannerList.filter((val) => selectedPlannerList[0] == val.email)
      if (result.length > 0) {
        return result[0].name;
      } else {
        return 'All';
      }
    }
    else if (selectedPlannerList.length === 1) {
      let result = plannerList.filter((val) => selectedPlannerList[0] == val.email)
      if (result.length > 0) {
        return result[0].name;
      } else {
        return 'All';
      }
    }
    return "Multiple selection";
  };

  const handleSaveFilter = () => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...",
    });

    let data = {
      ...savedFilter,
      cmoListFilter: SelectedCMOList,
      plantListFilter: selectedPlantIdList,
      plannerUserId: selectedPlannerList,
    };
    axios
      .post(`${appUrl}/user/saveDashboardFilters`, data)
      .then((res) => {
        // throw new Error("Mock Error");
        dispatch({
          type: DESTROY_BACKDROP,
        });
        if (res.data.status) {
          dispatch(fetchPurchaseOrdersFilters());
          setSavedSuccessfull(true);
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSaveFailed(true);
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSaveFailed(true);
      });

    // dispatch({
    //                 type: OPEN_BACKDROP,
    //                 backdropText: 'Please Wait...',
    //     });

    //     setTimeout(() => {
    //                 dispatch({
    //                   type: DESTROY_BACKDROP,
    //                 });
    //                 // setmainError('Something went wrong. Please try again.')
    //                 // errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //                 setSavedSuccessfull(true);
    //     }, 3000)
    // setFilteredPlantList(
    //   selectedPlantIdList.length > 0
    //     ? selectedPlantIdList
    //     : SelectedCMOList.length > 0
    //     ? plantList
    //         .filter((val) => SelectedCMOList.includes(val.vendorMosymphonyID))
    //         .map((val) => val.plantCode)
    //     : []
    // );

    // dispatch({
    //   type: FETCH_PURCHASE_ORDER_LOADING,
    //   payload: true,
    // });
    // dispatch(
    //   fetchPurchaseOrders({
    //     searchField: searchField,
    //     searchValue: searchValue,
    //     noOfDaysAgo: parseInt(filterByDate),
    //     collaboratorTypeID: tokenData.collaborator_type_id,
    //     vendorMosymphonyID: parseInt(vendorMosymphonyID),
    //     scheduleAgreementStatusID: parseInt(scheduleAgreementStatusID),
    //     fgPoApprovedFlag: true,
    //     plantCodeList:
    //       selectedPlantIdList.length > 0
    //         ? selectedPlantIdList
    //         : SelectedCMOList.length > 0
    //         ? plantList
    //             .filter((val) =>
    //               SelectedCMOList.includes(val.vendorMosymphonyID)
    //             )
    //             .map((val) => val.plantCode)
    //           : [],
    //           vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
    //     pageNumber: 1,
    //     pageSize: rowsPerPage,
    //   })
    // );
  };

  const handleCloseSave = () => {
    setSavedSuccessfull(false);
    dispatch(fetchPurchaseOrdersFilters());
  };

  const handleCheckboxChange = (id) => {
    setColumns(
      columns.map((column) =>
        column.id === id ? { ...column, active: !column.active } : column
      )
    );
  };

  const saveColumns = async () => {
    const url = `${smlUrl}/user/saveCustomizeColumns`;

    const data = {
      ...customizeTable,
      poApprovedColumn: columns,
    };

    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...",
    });
    try {
      axios
        .post(url, data)
        .then((res) => {
          console.log(res);
          setOpen(false);
          setSavedSuccessfull(true);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        })
        .catch((err) => {
          console.error(err);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSaveFailed(true);
        });
    } catch (error) {
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setSaveFailed(true);
    }
  };

  // Call the function when needed
  // saveColumns();

  // const handleSaveChanges = () => {
  //   const selectedColumns = columns.filter(column => column.selected);
  //   if (selectedColumns.length === 0) {
  //     alert("Please select at least one column.");
  //     return;
  //   }
  //   console.log("Selected Columns:", selectedColumns);
  //   setOpen(false);
  // };

  const handleSave = () => {
    saveColumns();
  };

  const handleViewComponentAllocationOpen = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/viewComponentAllocation`
    );
  };

  return (
    <React.Fragment>
      <BackDropLoading />
      <Grid container justifyContent='center' style={{ marginTop: "1rem" }}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent:'flex-start',
                // width: '30rem',
              }}
            >
              {/* Dropdown inside search bar for selecting field (e.g., COI, Treating Hospitals) */}
              <Box
                style={{
                  width: "30rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TextField
                  size='small'
                  select
                  value={searchField}
                  onChange={handleSearchField}
                  onKeyDown={(e) => e.key === "Enter" && handleSearchField()}
                  variant='outlined'
                  style={{
                    minWidth: 30,
                    border: "1px solid black",
                    borderRight: "none",
                    borderRadius: "0.1rem",
                    backgroundColor: "#F0F0F0",
                  }}
                >
                  <MenuItem value='all'>Select search by</MenuItem>
                  <MenuItem value='PO Number'>PO number</MenuItem>
                  <MenuItem value='Product Code'>Product code</MenuItem>
                  <MenuItem value='Product description'>
                    Product description
                  </MenuItem>
                  <MenuItem value='Supply type'>Supply type</MenuItem>
                  <MenuItem value='Drug type'>Drug type</MenuItem>
                  <MenuItem value='Plant type'>Plant type</MenuItem>
                </TextField>

                {/* <TextField
                size='small'
                value={searchValue}
                disabled={searchField === 'all'}
                onChange={(e) => {
                  if (searchField !== 'all') {
                    handleSearchValue(e)
                  }
                }
                } // Update search value on input
                onKeyDown={(e) => e.key === 'Enter' && handleSearchClick()} // Call API on Enter key
                variant='outlined'
                placeholder='Search'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {searchValue && (
                        <Tooltip title='Clear search' aria-label='clear'>
                          <Clear
                            fontSize='small'
                            onClick={handleClearSearch} // Clear search value
                            style={{
                              cursor: 'pointer',
                              color: 'dimgray',
                            }}
                          />
                        </Tooltip>
                       )} 
                      <IconButton
                        size='small'
                        style={{
                          backgroundColor: '#EB5E28',
                          color: 'white',
                          borderRadius: '0',
                          padding: '8px',
                          translate: '0.84rem',
                        }}
                        onClick={handleSearchClick} // Trigger API call on click
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                style={{
                  width: '100%',
                  flex: 1,
                  border: '1px solid black',
                  borderRadius: '0.1rem',
                }}
              /> */}

                {!["Supply type", "Drug type", "Plant type"].includes(
                  searchField
                ) && (
                  <TextField
                    size='small'
                    value={searchValue}
                    // onChange={(e) => setSearchValue(e.target.value)}
                    disabled={searchField === "all"}
                    onChange={(e) => {
                      if (searchField !== "all") {
                        handleSearchValue(e);
                      }
                    }} // Update search value on input
                    onBlur={(e)=>{
                      const { name, value} = e.target
                      if(typeof value === 'string' && value !== value.trim()){
                        handleSearchValue({ target: {name, value: value.trim()}})
                      }
                    }}
                    onKeyDown={(e) => {
                          const { name, value } = e.target;
                          if(e.key === "Enter"){
                            handleSearchValue({ target:{ name, value: value.trim() } });
                            handleSearchClick()
                          }
                        }} // Call API on Enter key
                    variant='outlined'
                    placeholder='Search'
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          {searchValue && (
                            <Tooltip title='Clear search' aria-label='clear'>
                              <Clear
                                fontSize='small'
                                onClick={handleClearSearch} // Clear search value
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                          <IconButton
                            size='small'
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "0",
                              padding: "8px",
                              translate: "0.84rem",
                            }}
                            onClick={handleSearchClick} // Trigger API call on click
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    style={{
                      width: "100%",
                      flex: 1,
                      border: "1px solid black",
                      borderRadius: "0.1rem",
                    }}
                  />
                )}

                {["Supply type", "Drug type", "Plant type"].includes(
                  searchField
                ) && (
                  <Autocomplete
                    options={
                      searchField === "Supply type"
                        ? supplyTypes
                        : searchField === "Drug type"
                        ? drugTypes
                        : searchField === "Plant type"
                        ? plantTypes
                        : []
                    }
                    getOptionLabel={(option) => {
                      if (searchField === "Supply type") {
                        return option.supplyType;
                      } else if (searchField === "Drug type") {
                        return option.drugType;
                      } else {
                        return option.plantType;
                      }
                    }}
                    value={searchSelectValue || null}
                    onChange={(e, value) => {
                      if (searchField !== "all") {
                        setSearchSelectValue(value);
                        if (typeof value === "object") {
                          setSearchValue(
                            searchField === "Supply type"
                              ? String(value.supplyTypeID)
                              : searchField === "Drug type"
                              ? String(value.drugTypeID)
                              : searchField === "Plant type"
                              ? String(value.plantTypeID)
                              : null
                          );
                        } else {
                          setSearchValue("");
                        }
                      }
                    }}
                    style={{
                      width: "100%",
                      flex: 1,
                      border: "1px solid black",
                      borderRadius: "0.1rem",
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={searchValue}
                        variant='outlined'
                        placeholder='Search'
                        onChange={(e) => {
                          if (searchField !== "all") {
                            handleSearchValue(e);
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          className: classes.inputBaseRoot,
                          endAdornment: (
                            <InputAdornment position='end'>
                              {searchValue && (
                                <Tooltip
                                  title='Clear search'
                                  aria-label='clear'
                                >
                                  <Clear
                                    fontSize='small'
                                    onClick={handleClearSearch} // Clear search value
                                    style={{
                                      cursor: "pointer",
                                      color: "dimgray",
                                    }}
                                  />
                                </Tooltip>
                              )}
                              <IconButton
                                size='small'
                                style={{
                                  backgroundColor: "#EB5E28",
                                  color: "white",
                                  borderRadius: "0",
                                  padding: "8px",
                                  translate: "0.84rem",
                                }}
                                onClick={handleSearchClick} // Trigger API call on click
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )} // Disable until PO is selected
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              {/* {localStorage.collabType !== "CMO" && (
                <Box display='flex' justifyContent='flex-end'>
                  <Button
                    variant='contained'
                    // startIcon={<Add />}
                    style={{ borderRadius: '20px' }}
                    // onClick={handleOpenAddNewUserScreen}
                    className={classes.blueButton}
                  >
                    Sync with SAP
                  </Button>
                </Box>
              )} */}
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "end",
                }}
              >
                <Grid item>
                  {screenAccess?.viewPOAttachmentsDashboard?.screenAccess && (
                    <StyledButton
                      // onClick={handleOpen}
                      endIcon={null}
                      className={classes.BtnSty1}
                    >
                      View PO attachments
                    </StyledButton>
                  )}
                </Grid>

                <Grid item>
                  {screenAccess?.viewComponentAllocationDashboard
                    ?.screenAccess && (
                    <StyledButton
                      // onClick={handleOpen}
                      onClick={handleViewComponentAllocationOpen}
                      className={classes.BtnSty1}
                      endIcon={null}
                    >
                      View Component allocation
                    </StyledButton>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Divider style={{ marginTop: "1rem" }} />
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            style={{ boxShadow: "none", margin: 0 }}
          >
            <AccordionSummary
              className={classes.accordionSummary}
              // expandIcon={<ExpandMoreIcon />}
            >
              <Grid container style={{ justifyContent: "space-between" }}>
                <Grid item>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                      style={{ marginRight: "8px" }}
                      onClick={() => setExpanded(!expanded)}
                      size='small'
                    >
                      {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                    <Typography
                      variant='body2'
                      style={{ paddingBottom: "inherit", fontWeight: 600 }}
                    >
                      Quick Summary:
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={3}
                style={{ justifyContent: "space-evenly" }}
              >
                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData
                      ?.committedQtyDeliveredPOCount
                      ? poQuickSummary?.quickSummaryData
                          ?.committedQtyDeliveredPOCount
                      : 0
                  }
                  lableText={"Committed qty. delivered"}
                />

                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData
                      ?.deliveryInLessThan30DaysPOCount
                      ? poQuickSummary?.quickSummaryData
                          ?.deliveryInLessThan30DaysPOCount
                      : 0
                  }
                  lableText={"Delivery in less than 30 days"}
                />

                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData
                      ?.deliveryIn30To60DaysPOCount
                      ? poQuickSummary?.quickSummaryData
                          ?.deliveryIn30To60DaysPOCount
                      : 0
                  }
                  lableText={"Delivery in 30 to 60 days "}
                />

                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData
                      ?.deliveryIn61To90DaysPOCount
                      ? poQuickSummary?.quickSummaryData
                          ?.deliveryIn61To90DaysPOCount
                      : 0
                  }
                  lableText={"Delivery in 61 to 90 days "}
                />

                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData
                      ?.deliveryInMoreThan90DaysPOCount
                      ? poQuickSummary?.quickSummaryData
                          ?.deliveryInMoreThan90DaysPOCount
                      : 0
                  }
                  lableText={"Delivery in more than 90 days"}
                />

                <Block
                  nonClickable={true}
                  loading={poQuickSummaryLoading}
                  count={
                    poQuickSummary?.quickSummaryData?.delayedPODeliveriesCount
                      ? poQuickSummary?.quickSummaryData
                          ?.delayedPODeliveriesCount
                      : 0
                  }
                  lableText={"Delayed deliveries "}
                />
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Divider />

          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "end",
                flexDirection: "row",
              }}
            >
              {localStorage.collabType !== "CMO" && (
                <React.Fragment>
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: "10px",
                    }}
                  >
                    <Grid>
                      <Typography style={{ fontWeight: "bold" }}>
                        CMO:
                      </Typography>
                    </Grid>

                    <Grid>
                      <FormControl
                        variant='outlined'
                        size='small'
                        style={{ width: "12rem", marginRight: "1rem" }}
                      >
                        <Select
                          multiple
                          fullWidth
                          name='cmo'
                          size='small'
                          variant='outlined'
                          displayEmpty
                          value={
                            SelectedCMOList.length > 0 ? SelectedCMOList : []
                          } // Fix: Ensures correct initial display
                          onChange={handleChangeCMOList}
                          onClose={() =>
                            handleSelectChangeListLosesFocus("cmo")
                          }
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "Multiple selection"
                              : getDisplayCMOFilterValue()
                          }
                        >
                          <MenuItem value='All'>
                            <Checkbox
                              checked={
                                SelectedCMOList.length ===
                                cmoMemberWithId.length
                              }
                            />
                            <ListItemText primary='All' />
                          </MenuItem>
                          {cmoMemberWithId.map((option) => {
                            return (
                              <MenuItem
                                key={option}
                                value={option.organization_id}
                              >
                                <Checkbox
                                  checked={
                                    SelectedCMOList.indexOf(
                                      option.organization_id
                                    ) > -1
                                  }
                                />
                                <ListItemText
                                  primary={option.organization_name}
                                />
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }}>
                    Plant ID:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant='outlined'
                    size='small'
                    style={{ width: "12rem", marginRight: "1rem" }}
                  >
                    <Select
                      multiple
                      fullWidth
                      name='plantID'
                      size='small'
                      variant='outlined'
                      displayEmpty
                      value={
                        selectedPlantIdList.length > 0
                          ? selectedPlantIdList
                          : []
                      } // Fix: Ensures correct initial display
                      onChange={handleChangePlantIdList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("plantID")
                      }
                      renderValue={(selected) =>
                        selected.length === 0
                          ? "Multiple selection"
                          : getDisplayPlantIDValue()
                      }
                    >
                      <MenuItem value='All'>
                        <Checkbox
                          checked={
                            selectedPlantIdList.length === plantList.length
                          }
                        />
                        <ListItemText primary='All' />
                      </MenuItem>
                      {plantList.map((option) => (
                        <MenuItem key={option} value={option.plantCode}>
                          <Checkbox
                            checked={
                              selectedPlantIdList.indexOf(option.plantCode) > -1
                            }
                          />
                          <ListItemText primary={option.plantCode} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {localStorage.collabType !== "CMO" &&
                String(localStorage.roleName).toLocaleLowerCase() !==
                  "planner" && (
                  <React.Fragment>
                    <Grid
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                        flexDirection: "column",
                        marginTop: "10px",
                      }}
                    >
                      <Grid>
                        <Typography style={{ fontWeight: "bold" }}>
                          Planner:
                        </Typography>
                      </Grid>

                      <Grid>
                        <FormControl
                          variant='outlined'
                          size='small'
                          style={{ width: "12rem", marginRight: "1rem" }}
                        >
                          <Select
                            multiple
                            fullWidth
                            size='small'
                            variant='outlined'
                            displayEmpty
                            value={
                              selectedPlannerList.length > 0
                                ? selectedPlannerList
                                : []
                            } // Fix: Ensures correct initial display
                            onChange={handleChangePlannerList}
                            onClose={() => handleSelectChangeListLosesFocus()}
                            renderValue={(selected) =>
                              selected.length === 0
                                ? "Multiple selection"
                                : getDisplayPlannerValue()
                            }
                          >
                            <MenuItem value='All'>
                              <Checkbox
                                checked={
                                  selectedPlannerList.length ===
                                  plannerList.length
                                }
                              />
                              <ListItemText primary='All' />
                            </MenuItem>
                            {plannerList.map((option) => {
                              return (
                                <MenuItem key={option} value={option.email}>
                                  <Checkbox
                                    checked={
                                      selectedPlannerList.indexOf(
                                        option.email
                                      ) > -1
                                    }
                                  />
                                  <ListItemText primary={option.name} />
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                )}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  flexDirection: "column",
                  marginTop: "1.5rem",
                }}
              >
                <Button
                  variant='contained'
                  color='primary'
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  className={classes.search}
                  onClick={handleSaveFilter}
                  style={{
                    borderRadius: "2rem",
                    textTransform: "none",
                    borderRadius: "2rem",
                  }}
                >
                  Save filters
                </Button>
              </Grid>

              {/* Clear filter */}
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant='caption'
                  style={{
                    justifyContent: "end",
                    fontSize: 12,
                    color: "blue",
                    marginLeft: "5px",
                  }}
                  className={classes.clearText}
                  onClick={handleClearFilters}
                >
                  Clear All Filters
                </Typography>
              </Grid>

              {/* ////////////   */}
            </Grid>

            <Grid item>
              <Grid
                container
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                }}
              >
                <Grid
                  item
                  style={{
                    // textDecoration: 'underline',
                    // fontStyle: 'italic',
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant='body2'
                    style={{ color: "gray", marginRight: "8px" }}
                  >
                    {`Last synced @ ${moment(new Date()).format(
                      "HH:mm:ss; DD MMMM, YYYY"
                    )}`}
                  </Typography>
                  <Grid>
                    <Typography
                      variant='body2'
                      color='primary'
                      style={{
                        textDecoration: "underline",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={handleRefresh}
                    >
                      Refresh
                      <Refresh color='primary' fontSize='small' />
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "10px",
                    width: "100%",
                  }}
                >
                  {featuresAccess?.customizeColumns && (
                    <StyledButton
                      // onClick={handleOpen}
                      onClick={() => {
                        setOpen(true);
                      }}
                      className={classes.BtnSty1}
                      style={{ marginRight: "2rem" }}
                      endIcon={null}
                    >
                      Customize columns
                    </StyledButton>
                  )}

                  {/* Button to open dialog */}

                  {/* Dialog Box */}
                  <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    classes={{ paper: classes.dialogPaper }}
                  >
                    <React.Fragment>
                      <BackDropLoading />
                      {/* Title Section */}
                      <DialogTitle disableTypography>
                        <Box
                          className={classes.titleContainer}
                          style={{ fontSize: "bold" }}
                        >
                          <Typography
                            variant='h5'
                            style={{ fontWeight: "500" }}
                          >
                            Customize Columns
                          </Typography>
                          {/* <Box>
             
              <Button
                onClick={() => setOpen(false)}
                color="secondary"
                className={classes.closeBtn}
              >
                Cancel
              </Button>
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }}/>
              </IconButton>
            </Box> */}

                          <Grid item xs={2} sm={2} md={2}>
                            <Typography
                              variant='body2'
                              className={classes.closeBtn}
                              onClick={() => setOpen(false)}
                            >
                              Cancel{" "}
                              <CloseIcon
                                onClick={() => setOpen(false)}
                                style={{
                                  fontSize: "35px",
                                  color: "#FF0000",
                                  cursor: "pointer",
                                }}
                              />
                            </Typography>
                          </Grid>
                        </Box>
                      </DialogTitle>

                      {/* Column Selection Checkboxes */}
                      <DialogContent>
                        <Grid container spacing={2}>
                          {columns.map((column) => (
                            <Grid item xs={4} key={column.id}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={column.active}
                                    onChange={() =>
                                      handleCheckboxChange(column.id)
                                    }
                                    style={{ color: "#ff5722" }}
                                  />
                                }
                                label={column.tableHeader} // Updated to use tableHeader
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </DialogContent>

                      {/* Centered Save Button */}
                      <Box className={classes.saveButtonContainer}>
                        <Button
                          className={classes.saveButton}
                          // onClick={() => setOpen(false)}
                          // onClick={handleSave}
                          onClick={handleSave}
                          endIcon={<span>&#x276F;</span>}
                          style={{ marginTop: "3rem" }} // Unicode for `>` symbol
                        >
                          Save changes
                        </Button>
                      </Box>
                    </React.Fragment>
                  </Dialog>

                  <Typography
                    style={{
                      fontWeight: "bold",
                      marginRight: "4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    PER PAGE
                  </Typography>
                  <FormControl variant='outlined' size='small'>
                    <Select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                    >
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            alignItems='center'
            style={{ paddingBottom: "1rem", paddingTop: "1rem" }}
          >
            <ApprovedPurchaseOrderTable
              loading={fetchPurchaseOrderDataLoading}
              tableData={
                Array.isArray(fetchPurchaseOrderData?.SADetails)
                  ? fetchPurchaseOrderData?.SADetails
                  : []
              }
              openPOLineDetails={openPOLineDetails}
              customizeTable={
                customizeTable?.poApprovedColumn
                  ? customizeTable.poApprovedColumn
                  : []
              }
              errors={errors}
              featuresAccess={featuresAccess}
            />
          </Grid>

          {showPagination === true &&
            fetchPurchaseOrderDataLoading === false && (
              // <Box
              //   style={{
              //     marginTop: 24,
              //     display: 'flex',
              //     justifyContent: 'center',
              //     alignItems: 'center',
              //     paddingRight: '2rem',
              //   }}
              // >
              //   <IconButton
              //     disabled={currentPage === 1}
              //     onClick={() => handlePageChange(currentPage - 1)}
              //   >
              //     <ChevronLeft />
              //   </IconButton>
              //   <Typography style={{ margin: '0 16px' }}>
              //     Page {currentPage} of {totalPages}
              //   </Typography>
              //   <IconButton
              //     disabled={currentPage === totalPages}
              //     onClick={() => handlePageChange(currentPage + 1)}
              //   >
              //     <ChevronRight />
              //   </IconButton>
              // </Box>
              <Grid
                container
                alignItems='center'
                justifyContent='center'
                style={{ paddingTop: "1rem" }}
              >
                <PaginationInput
                  totalPages={
                    purchaseOrderData?.numberOfPages
                      ? purchaseOrderData?.numberOfPages
                      : 0
                  }
                  handlePageChange={handlePageChange}
                  page={currentPage}
                />
              </Grid>
            )}
        </Grid>
      </Grid>
      <Dialog open={savedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Saved successfully"}
        />
      </Dialog>
      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent='flex-end'>
            <Typography
              variant='body2'
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize='large' />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ApprovedPurchaseOrderDashboard;
